import { ConsentKeys } from '../types/consents';

export const saveConsents = (values: Record<ConsentKeys, boolean>) => {
	const keys = Object.keys(values) as ConsentKeys[];

	for (const key of keys) {
		sessionStorage.setItem(key, values[key] ? 'true' : 'false');
	}
};
